import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 54787 24861"
    {...props}
  >
    <defs>
      <style>
        {
          // ".str0,.str1{stroke:#2b2a29;stroke-width:794.016}.str0{stroke:#1c1b17}.fil0{fill:none}.fil1{fill:#1c1b17}"
        }
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974338362416">
        <path
          d="M51679 439c11 64 17 130 17 196v7963c0 653-531 1184-1184 1184H4275c-653 0-1185-531-1185-1184V635c0-66 7-132 17-196C1595 567 397 1844 397 3388v18116c0 1628 1332 2960 2960 2960h48073c1628 0 2960-1332 2960-2960V3388c0-1544-1198-2821-2711-2949z"
          className="fill-none stroke1"
          style={{
            strokeWidth: 794.016,
          }}
        />
        <rect
          width={3943}
          height={627}
          x={45753}
          y={13262}
          className="fill"
          rx={15880}
          ry={15880}
        />
        <rect
          width={1989}
          height={627}
          x={39725}
          y={13262}
          className="fill"
          rx={15880}
          ry={15880}
        />
        <path
          d="M8031 7191h38724c134 0 248-101 248-222V994c0-59-28-115-73-155H7857c-45 41-73 96-73 155v5975c0 121 113 222 247 222z"
          className="fill-none stroke1"
          style={{
            strokeWidth: 794.016,
          }}
        />
        <rect
          width={26498}
          height={794}
          x={14145}
          y={18959}
          rx={9763}
          ry={14192}
          style={{
            stroke: "#1c1b17",
            strokeWidth: 794.016,
          }}
          className="fil1-bg stroke1"

        />
        <rect
          width={47427}
          height={5136}
          x={3679}
          y={16789}
          rx={1588}
          ry={1588}
          style={{
            stroke: "#2b2a29",
            strokeWidth: 1191.02,
          }}
          className="fil1-bg stroke1"

        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
